<template lang="pug">
  #app
    //b-navbar(toggleable='sm' fixed='top' variant='light')
      .container.d-flex.justify-content-between
        b-navbar-brand(href='#/', style="color: rgb(255, 159, 36);", align="center")
          img.d-inline-block.align-top(src="./assets/logo.png", style="height: 58px; margin: -15px 0;")
          //- | S.Holmes platform
          | Дом Шерлока в Минске

    .container-lg(v-if="isInit && isRuning", v-bind:class="{'is-full-view': isFullView}")
      .py-5.text-center.d-none.d-sm-block
        //- img.d-block.mx-auto.mb-4(src='./assets/logo.png', alt='', height='58')
        img.d-block.mx-auto.mb-4(src='//sherlockquiz.com/frontend/img/new/logo_1.png', alt='')
        h2 {{ game.oraganizator }}
        p.lead
          | {{ game.name }}

      .row(v-if="!isFullView")
        .col-12
          b-button.mb-3.mt-3.float-right.d-block.d-sm-block.d-md-none(v-bind:variant="isOpenModal ? 'success' : 'primary'", @click="isOpenModal = !isOpenModal;") {{ !isOpenModal ? 'Информация' : 'Закрыть' }}
      
      .row
        .col-md-8.order-md-1(v-bind:class="{'col-md-12' : isFullView}")
          b-overlay(:show='!serverSettings.translation', variant="warning", opacity="1")
            template(v-slot:overlay='')
              .text-center
                h5 Трансляция еще не началась
                img.d-inline-block.align-top(src="//sherlockquiz.com/frontend/img/new/logo_1.png")
            //- div.video-frame(v-if="!serverSettings.translation")
            //- div.video-frame(v-if="serverSettings.translation")
            
            b-aspect(aspect="16:9")
              div#sldp_player_wrapper(style="width: 100%; height: 100%;")
              //video#videojs-player.video-js.vjs-default-skin(controls, playsinline, autoplay, preload, style="width: 100%; height: 100%;")
                source(:src="buildTranslationUrl()", type='application/x-mpegURL')
            //div.video-frame
              video#videojs-player.video-js.vjs-default-skin.video-frame(controls, playsinline, autoplay)
                source(:src="buildTranslationUrl()", type='application/x-mpegURL')

          form.needs-validation(novalidate='')
            //.row
              .col-md-6.mb-3
                label(for='cc-name') Name on card
                input#cc-name.form-control(type='text', placeholder='', required='')
                small.text-muted Full name as displayed on card
                .invalid-feedback
                  | Name on card is required
              .col-md-6.mb-3
                label(for='cc-number') Credit card number
                input#cc-number.form-control(type='text', placeholder='', required='')
                .invalid-feedback
                  | Credit card number is required
            hr.mb-4

            .row
              .col-6
                .text-left(v-if="currentSlide")
                  h4 Тур {{ currentSlide.tour }}. 
                    span(v-if="currentSlide.type > 1") Вопрос {{ currentSlide.number }}
              .col-6
                .text-right(v-if="currentSlide && currentSlide.type > 1")
                  h4(v-bind:class="time > 0 ? 'text-success' : 'text-danger'") {{ formatTimer() }}
            
            hr.mb-4

            .input-group.mb-3
              input.form-control.form-control-lg(type='text', v-bind:placeholder="answeredMessage ? 'Ответ: ' + answeredMessage : 'Ваш ответ...'", aria-label="Ваш ответ...", aria-describedby='button-addon2', v-model="answerMessage", v-on:keyup.enter="sendAnswer();")
              .input-group-append
                button#button-addon2.btn.btn-warning(type='button', v-bind:disabled="!timer", @click="sendAnswer();", v-if="answeredMessage") Изменить
                button#button-addon2.btn(type='button', v-bind:disabled="!timer", @click="sendAnswer();", v-bind:class="timer ? 'btn-success':'btn-primary'", v-if="!answeredMessage") Отправить
                button#button-addon3.btn(type='button', @click="toggleFullView();", v-bind:class="isFullView ? 'btn-success':'btn-primary'")
                  b-icon(icon="aspect-ratio")
        
        .col-md-4.order-md-2.mb-4.d-none.d-md-block(v-bind:class="{'visiable-mobile-sidebar': isOpenModal}", v-if="!isFullView")
          b-card#sidebar-panel(no-body='')
            b-tabs(card='')
              b-tab(title='Чат', active='', no-body, v-if="serverSettings.chatText")
                b-card-body.online-chat#online-chat
                  div.mb-2(v-for="messageData in chatMessages")
                    small(v-bind:class="messageData.name ? 'text-primary' : 'text-danger'") {{ messageData.name ? messageData.name : 'Организатор' }}
                    div {{ messageData.msg }}
                  b-alert(v-if="!chatMessages || !chatMessages.length", variant='success', show='')
                    | Новых сообщений нет
                b-card-footer
                  b-input-group(v-if="serverSettings.chatTextTeamsAnswer")
                    b-form-input(placeholder='Сообщение', v-model="chatMessage", v-on:keyup.enter="chatSendMessage();")
                    b-input-group-append
                      b-button(variant='outline-secondary', @click="chatSendMessage();")
                        b-icon(icon="arrow-return-left")

              b-tab(title='Аудио', v-bind:disabled="!serverSettings.chatAudioTeams")
                b-card-text(v-if="noAudioMesage")
                  b-alert(show='', variant='danger') {{ noAudioMesage }}
                b-card-text(v-else) Аудио чат с моей команадой:
                //- .online-chat
                div.webrtc-list

              b-tab(title='Команда')
                b-card-text.text-center
                  h4 {{ team.name }}
                div.fluid.mb-4
                  b-row
                    b-col
                      b-img(src='//sherlockquiz.com/frontend/img/team_noimg.svg', alt='placeholder', thumbnail, center)
                //b-alert.text-center.team-alert.d-block.mx-auto(show='', variant='success')
                  p.text-center.small Играков
                  h3 3

    //.container
      router-view(:gameId="gameId")
      
    footer.container.center.pt-5.text-black-50.pb-2
      .row
        div.small.mx-auto 2020, Minsk, Arcom Group ltd.

    b-overlay(:show='!isInit', no-wrap, z-index="1032", variant="warning", opacity="1")
      template(v-slot:overlay='')
        .text-center
          h1 Игра еще не началась
          br
          br
          img.d-inline-block.align-top(src="//sherlockquiz.com/frontend/img/new/logo_1.png")
          
</template>

<script>
import logo from "./assets/logo.png"
import axios from "./scripts/axios"
import CONFIG from "./scripts/config"
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'app',

  data () {
    return {
      isPlayerInit: false,

      // Confs
      isRuning: false,
      isInit: true,
      isConnected: false,
      isSuportWebRtc: true,

      isOpenModal: false,
      isFullView: false,

      // Chat
      chatMessage: '',
      chatMessages: [],

      // Webgrtc
      noAudioMesage: '',
      local_media_stream: null, /* our own microphone / webcam */
      peers: {},                /* keep track of our peer connections, indexed by peer_id (aka socket.io id) */
      peer_media_elements: {},  /* keep track of our <video>/<audio> tags, indexed by peer_id */

      // Game
      timer: false,
      time: 0,
      timerDiabled: false,
      diffTime: 0,
      stateTime: null,
      diffTime: 0,

      answerMessage: '',
      answeredMessage: '',
    }
  },
  
  sockets: {
    connect: function () {
      console.log('socket connected');
      this.isConnected = true;

      const that = this;
      this.setup_local_media(function() {
        that.joinRoom();
      });
    },
    disconnect: function (data) {
        console.log('socket disconnect')
        this.isConnected = false;

        console.log("Disconnected from signaling server");
        /* Tear down all of our peer connections and remove all the
          * media divs when we disconnect */
        for (peer_id in this.peer_media_elements) {
            this.peer_media_elements[peer_id].remove();
        }
        for (peer_id in this.peers) {
            this.peers[peer_id].close();
        }

        this.peers = {};
        this.peer_media_elements = {};
    },

    // WEBRTC
    addPeer: function (config) {
        const that = this;
        console.log('Signaling server said to add peer:', config);

        var peer_id = config.peer_id;
        if (peer_id in this.peers) {
            /* This could happen if the user joins multiple channels where the other peer is also in. */
            console.log("Already connected to peer ", peer_id);
            return;
        }

        var peer_connection = new RTCPeerConnection(
            {"iceServers": CONFIG.ICE_SERVERS},
            {"optional": [{"DtlsSrtpKeyAgreement": true}]}
        );
        this.peers[peer_id] = peer_connection;

        peer_connection.onicecandidate = function(event) {
            if (event.candidate) {
                that.$socket.emit('relayICECandidate', {
                    'peer_id': peer_id, 
                    'ice_candidate': {
                        'sdpMLineIndex': event.candidate.sdpMLineIndex,
                        'candidate': event.candidate.candidate
                    }
                });
            }
        }

        peer_connection.onaddstream = function(event) {
            console.log("onAddStream", event);
            var remote_media = CONFIG.USE_VIDEO ? $("<video>") : $("<audio>");
            remote_media.attr("autoplay", "autoplay");
            remote_media.attr("controls", "");
            that.peer_media_elements[peer_id] = remote_media;
            $('.webrtc-list').append(remote_media);

            remote_media[0].srcObject = event.stream;
            that.updateParamsBySettings();
        }

        /* Add our local stream */
        peer_connection.addStream(this.local_media_stream);

        /* Only one side of the peer connection should create the
          * offer, the signaling server picks one to be the offerer. 
          * The other user will get a 'sessionDescription' event and will
          * create an offer, then send back an answer 'sessionDescription' to us
          */
        if (config.should_create_offer) {
            console.log("Creating RTC offer to ", peer_id);
            peer_connection.createOffer(
                function (local_description) { 
                    console.log("Local offer description is: ", local_description);
                    peer_connection.setLocalDescription(local_description,
                        function() { 
                            that.$socket.emit('relaySessionDescription', {'peer_id': peer_id, 'session_description': local_description});
                            console.log("Offer setLocalDescription succeeded"); 
                        },
                        function() { Alert("Offer setLocalDescription failed!"); }
                    );
                },
                function (error) {
                    console.log("Error sending offer: ", error);
                });
        }
    },
    sessionDescription: function (config) {
        const that = this;

        console.log('Remote description received: ', config);
        var peer_id = config.peer_id;
        var peer = this.peers[peer_id];
        var remote_description = config.session_description;
        console.log(config.session_description);

        var desc = new RTCSessionDescription(remote_description);
        var stuff = peer.setRemoteDescription(desc, 
            function() {
                console.log("setRemoteDescription succeeded");
                if (remote_description.type == "offer") {
                    console.log("Creating answer");
                    peer.createAnswer(
                        function(local_description) {
                            console.log("Answer description is: ", local_description);
                            peer.setLocalDescription(local_description,
                                function() { 
                                    that.$socket.emit('relaySessionDescription', {'peer_id': peer_id, 'session_description': local_description});
                                    console.log("Answer setLocalDescription succeeded");
                                },
                                function() { Alert("Answer setLocalDescription failed!"); }
                            );
                        },
                        function(error) {
                            console.log("Error creating answer: ", error);
                            console.log(peer);
                        });
                }
            },
            function(error) {
                console.log("setRemoteDescription error: ", error);
            }
        );
        console.log("Description Object: ", desc);
    },
    iceCandidate: function (config) {
        var peer = this.peers[config.peer_id];
        var ice_candidate = config.ice_candidate;
        peer.addIceCandidate(new RTCIceCandidate(ice_candidate));
    },
    removePeer: function (config) {
        const that = this;

        console.log('Signaling server said to remove peer:', config);
        var peer_id = config.peer_id;
        if (peer_id in that.peer_media_elements) {
            that.peer_media_elements[peer_id].remove();
        }
        if (peer_id in this.peers) {
            this.peers[peer_id].close();
        }

        delete this.peers[peer_id];
        delete that.peer_media_elements[config.peer_id];
    },

    chatMessageToClients: function (data) {
      this.chatMessages.push(data);
      this.updateScroll();
    },
    reinit: function () {
      document.location.reload(true);
    },
    answer: function (data) {
      if (data && data.tid && data.str) {
        if (data.tid && this.team.id) {
          this.answeredMessage = data.str;
        }
      }
    },
  },

  computed: {
    ...mapGetters([
      'team',
      'game',
      'slides',
      'currentSlideId',
      'currentSlide',
      'serverSettings',
      'timerStartTime',
    ]),
  },

  watch: {
    isConnected(value) {
      // this.joinRoom();
    },
    currentSlideId(newSlideId, oldSlideId) {
      this.time = this.currentSlide.timeout;

      if (this.answerMessage && !this.answeredMessage) {
        this.sendAnswer(oldSlideId)
      }

      this.answeredMessage = '';
      this.answerMessage = '';
    },
    serverSettings: {
      handler: function (val, oldVal) {
        this.updateParamsBySettings();

        // Проверка на изменение параметра translation
        if (val.translation !== oldVal.translation){
          if (!this.serverSettings.translation) {
            this.destroyPlayer();
          } else {
            // Если плеер уже инитился, то нужно стриницу перезагружать, потому как есть проблема с переинитом плеера
            if (this.isPlayerInit) {
              document.location.reload(true);
            } else {
              this.reinitPlayer();
            }
          }
        }
      },
      deep: true
    },
    timerStartTime(value) {
      this.time = this.currentSlide.timeout;
      this.timerDiabled = false;

      if (value - this.diffTime > Date.now() / 1000) {
        if (value !== this.stateTime) {
          this.stateTime = value
          this.startTimer()
        }
      } else {
        this.stopTimer()
      }
    }
  },

  async mounted() {
    const that = this;
    const urlParams = new URLSearchParams(window.location.search)
    const gameId = urlParams.get('gid')
    const teamId = urlParams.get('tid')

    if (gameId && teamId) {
      localStorage.setItem('teamId', teamId);
      localStorage.setItem('gameId', gameId);

      window.location.href = window.location.origin;
      return;
    }

    this.isRuning = true;

    try {
      const responseGame = await axios.get('/game/'+this.game.id)
      this.applyGame(responseGame.data);

      const responseMessages = await axios.get('/game/'+this.game.id+'/messages');
      this.chatMessages = responseMessages.data;
      this.updateScroll();

      this.isInit = true;
    } catch (e) {
      console.log(e);
      this.isInit = false;
      // alert('Ошибка запуска игры')
    }

    // Забираем сохраненненные настройки
    this.$store.dispatch('persissantDataFromStorageServer');
  },

  methods: {
    applyGame(gameData) {
      this.$store.dispatch('setGame', gameData);
      this.isInit = true;

      this.updateState();
    },

    chatSendMessage() {
      this.$socket.emit('chatMessage', {
        gameId: this.game.id,
        teamId: this.team.id,
        message: this.chatMessage,
      });
      this.chatMessage = '';
    },

    joinRoom() {
      this.$socket.emit('joinRooms', {
        gameId: this.game.id,
        teamId: this.team.id,
      });
    },

    toggleFullView() {
      if (!this.isFullView) {
        this.isFullView = true;
      } else {
        this.isFullView = false;
      }

      this.isOpenModal = false;
    },

    updateScroll() {
      setTimeout(() => {
        let container = this.$el.querySelector("#online-chat");
        container.scrollTop = container.scrollHeight + 15;
      }, 300);
    },

    destroyPlayer() {
      if (window.player) {
        // window.player.dispose();
        window.player.destroy();
      }
    },

    reinitPlayer() {
      if (this.isPlayerInit) {
        return;
      }
      this.isPlayerInit = true;

      if (window.player) {
        window.player.dispose();
      }

      window.player = SLDP.init({
        container: 'sldp_player_wrapper',
        stream_url: "ws://stream2.24guru.by:8081/stream/sherlock2331",
        // stream_url: "ws://stream2.24guru.by:8081/abr_app/sherlock2331",
        height: 'parent',
        width: 'parent',
        latency_tolerance: 0,
        offset: 0,
        buffering: 0,
        adaptive_bitrate: true,
        aspect_ratio: '16:9',
        autoplay: true
      });

      // let player = window.player = videojs("videojs-player", {
      //   html5: {
      //         hlsjsConfig: {
      //           // debug: true,
      //         }
      //     }
      // });

      // player.mediainfo = player.mediainfo || {};
      // player.mediainfo.projection = "90";
      // player.on("contextmenu", function(e) {
      //     e.preventDefault();
      // });
    },

    buildTranslationUrl() {
      return 'https://stream2.24guru.by:8443/live/sherlock'+ this.game.id +'.m3u8';
    },

    async updateState() {
      let responseState = await axios.get('/game/'+this.game.id+'/state');

      if (responseState && responseState.data && responseState.data.ts) {
        this.diffTime = responseState.data.ts - Math.floor(Date.now() / 1000);
        console.log('DIFF', this.diffTime);
      }
      
      this.$store.dispatch('socket_state', responseState.data);
    },

    sendAnswer(forceId = null) {
      const that = this;

      if (this.timer || forceId) {
        axios.post('/answer/'+this.game.id, {
          team_id: this.team.id,
          slide_id: forceId || this.currentSlideId,
          answer: this.answerMessage,
        }).then(() => {
          if (!forceId) {
            that.answeredMessage = that.answerMessage;
          }
          that.answerMessage = '';
        });
      }
    },

    // WEBRTC
    setup_local_media(callback, errorback) {
      let that = this;
      if (this.local_media_stream != null) {  /* ie, if we've already been initialized */
          if (callback) callback();
          return;
      }
      /* Ask user for permission to use the computers microphone and/or camera, 
        * attach it to an <audio> or <video> tag if they give us access. */
      console.log("Requesting access to local audio / video inputs");

      navigator.getUserMedia = ( navigator.getUserMedia ||
              navigator.webkitGetUserMedia ||
              navigator.mozGetUserMedia ||
              navigator.msGetUserMedia);

      const streamHandler = function(stream) { /* user accepted access to a/v */
        console.log("Access granted to audio/video");
        that.local_media_stream = stream;

        var local_media = CONFIG.USE_VIDEO ? $("<video>") : $("<audio>");
        local_media.attr("autoplay", "autoplay");
        local_media.attr("muted", "true"); /* always mute ourselves by default */
        local_media[0].muted = true;
        local_media.attr("controls", "");
        $('.webrtc-list').append(local_media);
        local_media[0].srcObject = stream;

        that.updateParamsBySettings();
        if (callback) callback();
      };
      
      const errorHandler = function() { /* user denied access to a/v */
          console.log("Access denied for audio/video");
          that.noAudioMesage = "Вы не предоставили доступ к микрофону, или ваш браузер не поддерживает данный функционал, аудио чат не будет работать.";
          if (errorback) errorback();
      };

      try {
        if (typeof navigator.mediaDevices.getUserMedia === 'undefined') {
          navigator.getUserMedia({"audio": CONFIG.USE_AUDIO, "video": CONFIG.USE_VIDEO}, streamHandler, errorHandler);
        } else {
          navigator.mediaDevices.getUserMedia({"audio": CONFIG.USE_AUDIO, "video": CONFIG.USE_VIDEO}).then(streamHandler).catch(errorHandler);
        }
      } catch (err) {
        this.isSuportWebRtc = false;
        this.noAudioMesage = 'Ваш браузер не поддерживает функцию общения с сокомандниками. Вы можете воспользовать компьтером и браузером Chrome для активации данной функции';
      }
    },
    part_chat_channel(channel) {
      this.$socket.emit('part', channel);
    },

    // Other
    updateParamsBySettings() {
      if (this.serverSettings.chatAudioTeams) {
        Object.keys(this.peer_media_elements).forEach((peer_id) => {
          this.peer_media_elements[peer_id][0].play();
        });
      } else {
        Object.keys(this.peer_media_elements).forEach((peer_id) => {
          this.peer_media_elements[peer_id][0].pause();
        });
      }
    },

    // TIMER
    formatTimer() {
      let seconds = this.time % 60;
      let t = Math.floor((this.time - seconds) / 60);
      let minutes = t % 60;
      t = Math.floor((t - minutes) / 3600);
      let hours = Math.floor(t / 60);

      let items = [minutes, seconds].map(function(val) {
          return +val < 10 ? '0' + val : val;
      });

      return items.join(':');
    },
    startTimer() {
      this.timer = true
      const currentTime = Math.round(Date.now() / 1000) + this.diffTime
      this.time = this.stateTime - currentTime
      this.timerTick()
    },
    stopTimer () {
      if (this.timer) {
        this.time = this.currentSlide.timeout
        this.timer = false
      }
    },
    timerTick() {
      if (this.timer) {
        return setTimeout(() => {
          if (this.time < 1) {
            this.time = 0
          } else {
            if (this.timer) {
              const currentTime = Math.round(Date.now() / 1000) + this.diffTime
              this.time = this.stateTime - currentTime
              this.timerTick()
            }
          }
        }, 1000)
      }
    }
  }
}
</script>

<style>
  body {
    /* padding-top: 80px; */
  }

  .fix-ovefflow-auto {
    overflow: auto;
  }

  .online-chat {
    height: 485px;
    overflow-y: auto;
  }

  /* #sidebar-panel {
    min-height: 20px;
  } */

  .video-frame {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    width: 100%;
    height: 440px;
    /* overflow: hidden; */
  }
  
  .novideo-frame {
    width: 100%;
    height: 440px;
  }

  .is-full-view .video-frame, .is-full-view .novideo-frame {
    width: 100%;
    height: 523px;
    
  }

  .video-js {
    border-radius: 4px;
  }

  .video-frame video {
    border-radius: 3px;
  }

  .team-alert {
    width: 150px;
  }

  @media only screen and (max-width: 768px)  {
    .visiable-mobile-sidebar {
      display: block !important;
      position: fixed;
      z-index: 9999;
      background-color: #f8f9fa;
      height: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/App.vue